import * as yup from "yup";

import { CaseActionFormValues } from "src/cases/caseView/schema";

const isFalsy = (value: unknown): boolean => {
  if (!value) return true;
  if (Array.isArray(value)) return !value.length;
  if (typeof value !== "string") return false;
  return !(value as string).trim().length;
};

/**
 * Strip invalid or falsy values from form values
 */
export const stripInvalidValues = <
  T extends Record<string, unknown> = CaseActionFormValues,
>(
  formSchema: yup.ObjectSchema<T>,
  obj: Partial<T>,
): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => {
      if (key === "action_key") return false;

      const fieldSchema = formSchema.fields[key] as yup.AnySchema | undefined;
      if (!fieldSchema) return false;

      const isValid = fieldSchema?.isValidSync(value);
      return isValid && !isFalsy(value);
    }),
  ) as Partial<T>;
};

/**
 * Transform form values to payload for submission
 */
export const transformFormValuesToPayload = <
  T extends Record<string, unknown> = CaseActionFormValues,
>(
  schema: yup.ObjectSchema<T>,
  obj: Partial<T>,
) => {
  // Remove action_key from the payload
  const transformedObject = schema.cast(obj, {
    stripUnknown: true,
  }) as Partial<T>;

  return stripInvalidValues<T>(schema, transformedObject);
};
